import * as React from 'react';
import { css } from '@emotion/core';
import { TABLE_COLORS, COLORS } from '../globalStyle/colors';
import LocalDiv from '../localization/LocalDiv';
import { Link } from 'react-router-dom';
import { getProjectStatus, statusToColor } from './module';
import { useMsgText } from '../localization/hooks';
import { Str } from '../localization/translationKeys';
import Msg from '../localization/Msg';
import { Project } from './models';
import { btnStyle } from '../forms/styles/button';
import { useAppState } from '../core/redux/hooks';


const styles = {
  root:    css`
    background-color: ${TABLE_COLORS.DARK_BG};
    padding: 10px 25px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
  `,
  dataRow: css`
    display: flex;
    flex-direction: row;
    margin-bottom: 5px;
  `,
  label:   css`
    font-weight: bold;
  `,
  link:    css`
    display: block;
    width: 180px;
  `,
};

type Props = {
  project: Project;
  projectRoute: string;
  className?: string;
};


const renderDataPoint = (labelKey: string, labelDefault: string, value: string, color: string): React.ReactNode => (
  <LocalDiv css={styles.dataRow}>
    <Msg str={labelKey} css={styles.label} />
    <span>:</span>
    <span>&nbsp;</span>
    <span css={css`color: ${color};`}>{value}</span>
  </LocalDiv>
);


/**
 * ProjectCard: a component that renders a summary for a project, including a link to go view that project.
 * Mostly used on mobile.
 *
 * PureComponent: true
 * Redux Connected: false
 */
const ProjectCard: React.FC<Props> = props => {
  const selectMsg = useMsgText(Str.Select);
  const status    = React.useMemo(() => getProjectStatus(props.project), [props.project]);
  const statusKey = props.project.statusMessageKey;
  const color     = React.useMemo(() => statusToColor(status), [status]);
  const code      = useAppState(state => state.locale.lang.code);

  return (
    <LocalDiv css={styles.root} className={props.className}>
      {
        renderDataPoint(Str.Project, 'Project', props.project.surveyName, COLORS.BLACK)
      }
      {
        renderDataPoint(
          Str.SurveyDeadline,
          'Survey Deadline',
          new Date(props.project.surveyDeadline).toLocaleDateString(code),
          COLORS.BLACK,
        )
      }
      <LocalDiv css={styles.dataRow}>
        <Msg str={Str.Status} css={styles.label} />
        <span>:</span>
        <span>&nbsp;</span>
        <Msg str={statusKey} css={css`color: ${color};`} />
      </LocalDiv>
      <Link
        to={props.projectRoute}
        css={[btnStyle.primary(color), styles.link]}
      >
        {selectMsg}
      </Link>
    </LocalDiv>
  );
};

export default ProjectCard;
